<app-header-three></app-header-three>
<!-- Banner Start -->
<div class="banner banner-3">

    <div class="banner-slider-3">

      <div class="banner-item">
        <div class="banner-inner" style="background-image: url('assets/img/banner/3.jpg')">
          <h1 class="title">Pepperoni </h1>
          <div class="ct-rating-wrapper">
            <div class="ct-rating">
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div class="banner-text">
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <div class="banner-icons-wrapper">
              <div class="banner-icon">
                <i class="flaticon-calories"></i>
                <div class="banner-icon-body">
                  <h5>650</h5>
                  <span>Calories</span>
                </div>
              </div>
              <div class="banner-icon">
                <i class="flaticon-cheese"></i>
                <div class="banner-icon-body">
                  <h5>200g</h5>
                  <span>Mozarella</span>
                </div>
              </div>
            </div>
            <div class="banner-controls">
              <a href="#" class="btn-custom primary">Order <i class="flaticon-shopping-bag"></i> </a>
              <h4>$12.99</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner" style="background-image: url('assets/img/banner/4.jpg')">
          <h1 class="title">Italian</h1>
          <div class="ct-rating-wrapper">
            <div class="ct-rating">
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div class="banner-text">
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <div class="banner-icons-wrapper">
              <div class="banner-icon">
                <i class="flaticon-calories"></i>
                <div class="banner-icon-body">
                  <h5>650</h5>
                  <span>Calories</span>
                </div>
              </div>
              <div class="banner-icon">
                <i class="flaticon-cheese"></i>
                <div class="banner-icon-body">
                  <h5>200g</h5>
                  <span>Mozarella</span>
                </div>
              </div>
            </div>
            <div class="banner-controls">
              <a href="#" class="btn-custom primary">Order <i class="flaticon-shopping-bag"></i> </a>
              <h4>$12.99</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner" style="background-image: url('assets/img/banner/5.jpg')">
          <h1 class="title">Vegetarian</h1>
          <div class="ct-rating-wrapper">
            <div class="ct-rating">
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
            </div>
          </div>
          <div class="banner-text">
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <div class="banner-icons-wrapper">
              <div class="banner-icon">
                <i class="flaticon-calories"></i>
                <div class="banner-icon-body">
                  <h5>650</h5>
                  <span>Calories</span>
                </div>
              </div>
              <div class="banner-icon">
                <i class="flaticon-cheese"></i>
                <div class="banner-icon-body">
                  <h5>200g</h5>
                  <span>Mozarella</span>
                </div>
              </div>
            </div>
            <div class="banner-controls">
              <a href="#" class="btn-custom primary">Order <i class="flaticon-shopping-bag"></i> </a>
              <h4>$12.99</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="banner-item">
        <div class="banner-inner" style="background-image: url('assets/img/banner/6.jpg')">
          <h1 class="title">Swiss</h1>
          <div class="ct-rating-wrapper">
            <div class="ct-rating">
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star active"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div class="banner-text">
            <p class="subtitle">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <div class="banner-icons-wrapper">
              <div class="banner-icon">
                <i class="flaticon-calories"></i>
                <div class="banner-icon-body">
                  <h5>650</h5>
                  <span>Calories</span>
                </div>
              </div>
              <div class="banner-icon">
                <i class="flaticon-cheese"></i>
                <div class="banner-icon-body">
                  <h5>200g</h5>
                  <span>Mozarella</span>
                </div>
              </div>
            </div>
            <div class="banner-controls">
              <a href="#" class="btn-custom primary">Order <i class="flaticon-shopping-bag"></i> </a>
              <h4>$12.99</h4>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="ct-arrows-wrapper">
      <div class="slide-number">
        <span class="current-slide">0<span>1</span></span> <span>/4</span>
      </div>
      <div class="ct-arrows">
        <div class="slider-prev">
          Previous
        </div>
        <div class="slider-next">
          Next
        </div>
      </div>
    </div>

  </div>
  <!-- Banner End -->

  <!-- Menu Categories Start -->
  <div class="ct-menu-categories menu-filter">
    <div class="container">
      <div class="menu-category-slider">
        <a href="#" data-filter="*" class="ct-menu-category-item active">
          <div class="menu-category-thumb">
            <img src="assets/img/categories/6.jpg" alt="category">
          </div>
          <div class="menu-category-desc">
            <h6>All</h6>
          </div>
        </a>
        <a href="#" data-filter=".sides" class="ct-menu-category-item">
          <div class="menu-category-thumb">
            <img src="assets/img/categories/1.jpg" alt="category">
          </div>
          <div class="menu-category-desc">
            <h6>Sides</h6>
          </div>
        </a>
        <a href="#" data-filter=".pizzas" class="ct-menu-category-item">
          <div class="menu-category-thumb">
            <img src="assets/img/categories/2.jpg" alt="category">
          </div>
          <div class="menu-category-desc">
            <h6>Pizzas</h6>
          </div>
        </a>
        <a href="#" data-filter=".salads" class="ct-menu-category-item">
          <div class="menu-category-thumb">
            <img src="assets/img/categories/3.jpg" alt="category">
          </div>
          <div class="menu-category-desc">
            <h6>Salads</h6>
          </div>
        </a>
        <a href="#" data-filter=".pasta" class="ct-menu-category-item">
          <div class="menu-category-thumb">
            <img src="assets/img/categories/7.jpg" alt="category">
          </div>
          <div class="menu-category-desc">
            <h6>Pasta</h6>
          </div>
        </a>
        <a href="#" data-filter=".desserts" class="ct-menu-category-item">
          <div class="menu-category-thumb">
            <img src="assets/img/categories/4.jpg" alt="category">
          </div>
          <div class="menu-category-desc">
            <h6>Desserts</h6>
          </div>
        </a>
        <a href="#" data-filter=".beverages" class="ct-menu-category-item">
          <div class="menu-category-thumb">
            <img src="assets/img/categories/5.jpg" alt="category">
          </div>
          <div class="menu-category-desc">
            <h6>Beverages</h6>
          </div>
        </a>
        <a href="#" data-filter=".offers" class="ct-menu-category-item">
          <div class="menu-category-thumb">
            <img src="assets/img/categories/8.jpg" alt="category">
          </div>
          <div class="menu-category-desc">
            <h6>Offers</h6>
          </div>
        </a>
      </div>
    </div>
  </div>
  <!-- Menu Categories End -->

  <!-- Menu Wrapper Start -->
  <div class="section section-padding">
    <div class="container">

      <div class="menu-container row menu-v2">

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 pizzas">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/5.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Pepperoni</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star"></i>
                    <i class="fas fa-star"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">12.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 beverages desserts">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/13.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Rum With Soda</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              </div>
              <div class="product-controls">
                <p class="product-price">3.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 desserts">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/12.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Chocolate Cookies</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              </div>
              <div class="product-controls">
                <p class="product-price">4.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 pizzas offers">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/2.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Vegetarian</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">9.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 pasta">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/11.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Sea Food Pasta</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">14.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 beverages offers">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/10.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Russian Beer</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
              </div>
              <div class="product-controls">
                <p class="product-price">14.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 pizzas">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/3.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Four Cheese</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">13.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 salads sides">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/15.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Ceaser Salad</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">10.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

        <!-- Product Start -->
        <div class="col-lg-4 col-md-6 sides">
          <div class="product">
            <div class="favorite">
              <i class="far fa-heart"></i>
            </div>
            <a class="product-thumb" routerLink='/menu-item-v1'> <img src="assets/img/prods-sm/14.png" alt="menu item" /> </a>
            <div class="product-body">
              <div class="product-desc">
                <h4> <a routerLink='/menu-item-v1'>Chicken Wrap</a> </h4>
                <div class="ct-rating-wrapper">
                  <div class="ct-rating">
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                    <i class="fas fa-star active"></i>
                  </div>
                </div>
                <p>Li Europan lingues es membres del sam familie. Lor separat existentie es un myth. Por scientie, musica, sport etc</p>
                <a href="#" class="btn-custom light btn-sm shadow-none" data-toggle="modal" data-target="#customizeModal"> Customize <i class="fas fa-plus"></i> </a>
              </div>
              <div class="product-controls">
                <p class="product-price">5.99$</p>
                <a href="#" class="order-item btn-custom btn-sm shadow-none">Order <i class="fas fa-shopping-cart"></i> </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Product End -->

      </div>

    </div>
  </div>
  <!-- Menu Wrapper End -->

  <!-- Infographics Start -->
  <div class="section section-padding bg-cover bg-center bg-parallax dark-overlay dark-overlay-2" style="background-image: url('assets/img/subheader-2.jpg')">
    <div class="container">
      <div class="section-title-wrap section-header text-center">
        <h2 class="title text-white">Our success Story</h2>
        <p class="subtitle text-white">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </p>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-employee"></i>
            <h4>24,934</h4>
            <p>Happy Customers</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-pizza-slice"></i>
            <h4>65,317</h4>
            <p>Pizzas Made</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-cheese"></i>
            <h4>4,658</h4>
            <p>Cheese Rolls</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-soda"></i>
            <h4>67,335</h4>
            <p>Drinks Served</p>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- Infographics End -->

  <!-- Order Online Start -->
  <div class="section">

    <div class="container">
      <div class="section text-center cta-2 cta bg-cover bg-center dark-overlay dark-overlay-2 bg-parallax" style="background-image: url('assets/img/bg/cta-2.jpg')">
        <div class="section-title-wrap section-header text-center">
          <h5 class="custom-primary">Get Crafty</h5>
          <h2 class="title text-white">Build Your Own Pizza Today</h2>
          <p class="subtitle text-white">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
          </p>
        </div>
        <a routerLink='/menu-item-v2' class="btn-custom shadow-none">Build Your Pizza</a>
      </div>

      <div class="container">
        <div class="gallery-slider">
          <a href="assets/img/blog/2.jpg" class="gallery-thumb">
            <img src="assets/img/blog/2.jpg" alt="post">
          </a>
          <a href="assets/img/blog/3.jpg" class="gallery-thumb">
            <img src="assets/img/blog/3.jpg" alt="post">
          </a>
          <a href="assets/img/blog/4.jpg" class="gallery-thumb">
            <img src="assets/img/blog/4.jpg" alt="post">
          </a>
          <a href="assets/img/blog/5.jpg" class="gallery-thumb">
            <img src="assets/img/blog/5.jpg" alt="post">
          </a>
          <a href="assets/img/blog/6.jpg" class="gallery-thumb">
            <img src="assets/img/blog/6.jpg" alt="post">
          </a>
          <a href="assets/img/blog/8.jpg" class="gallery-thumb">
            <img src="assets/img/blog/8.jpg" alt="post">
          </a>
        </div>
      </div>

    </div>

  </div>
  <!-- Order Online End -->

  <!-- Icons Start -->
  <div class="section pt-0">
    <div class="container">
      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">How We Do It</h5>
        <h2 class="title">We Deliver Your Food In 4 Steps</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </p>
      </div>

      <div class="row infographics-2">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-online-booking"></i>
            <h4>Order</h4>
            <p>There are many variations of passages of Lorem Ipsum available</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-calories"></i>
            <h4>Cook</h4>
            <p>There are many variations of passages of Lorem Ipsum available</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-delivery-man"></i>
            <h4>Deliver</h4>
            <p>There are many variations of passages of Lorem Ipsum available</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="ct-infographic-item">
            <i class="flaticon-food-tray"></i>
            <h4>Enjoy</h4>
            <p>There are many variations of passages of Lorem Ipsum available</p>
          </div>
        </div>
      </div>

      <div class="section-btn">
        <a routerLink='/menu-v1' class="btn-custom">Order Online</a>
      </div>

    </div>
  </div>
  <!-- Icons End -->

  <!-- Instagram Start -->
  <div class="section pt-0">
    <div class="container">

      <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Instagram</h5>
        <h2 class="title">We Love Sharing What We Do</h2>
        <p class="subtitle">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
        </p>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-6">
          <a href="#" class="ct-ig-item ig-2">
            <img src="assets/img/ig/1.jpg" alt="ig">
          </a>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-6">
          <a href="#" class="ct-ig-item ig-2">
            <img src="assets/img/ig/2.jpg" alt="ig">
          </a>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-6">
          <a href="#" class="ct-ig-item ig-2">
            <img src="assets/img/ig/3.jpg" alt="ig">
          </a>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-6">
          <a href="#" class="ct-ig-item ig-2">
            <img src="assets/img/ig/4.jpg" alt="ig">
          </a>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-6">
          <a href="#" class="ct-ig-item ig-2">
            <img src="assets/img/ig/5.jpg" alt="ig">
          </a>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-6">
          <a href="#" class="ct-ig-item ig-2">
            <img src="assets/img/ig/6.jpg" alt="ig">
          </a>
        </div>
      </div>

    </div>
  </div>
  <!-- Instagram End -->

  <!-- Newsletter start -->
  <section class="section bg-center bg-cover dark-overlay" style="background-image:url('assets/img/bg/1.jpg')">
    <div class="container">

      <div class="ct-newsletter">

        <div class="section-title-wrap section-header">
          <h2 class="title">Join Our Newsletter</h2>
          <p class="subtitle">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
          </p>
        </div>

        <form method="post">
          <input type="email" class="form-control" placeholder="Enter your email address" value="">
          <button type="submit" class="btn-custom primary" name="button"> Submit <i class="far fa-paper-plane"></i> </button>
        </form>

      </div>

    </div>
  </section>
  <!-- Newsletter End -->
<app-footer></app-footer>